import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { MenuDropdownContext } from "./MenuContext";
import { MenuItem as MenuItemInner } from "@szhsin/react-menu";
export function MenuItem(props) {
    const { menuItemHoverClassName, menuItemDisabledClassName, menuItemClassName } = React.useContext(MenuDropdownContext);
    const { className, ...rest } = props;
    const menuItemClassNameFn = ({ hover, disabled, submenu }) => {
        const array = [];
        if (className)
            array.push(className);
        if (menuItemClassName)
            array.push(menuItemClassName);
        if (hover && menuItemHoverClassName)
            array.push(menuItemHoverClassName);
        if (disabled && menuItemDisabledClassName)
            array.push(menuItemDisabledClassName);
        return array.join(" ");
    };
    return _jsx(MenuItemInner, { ...rest, className: menuItemClassNameFn });
}
